import React from 'react';

interface IIconCatering {
  width?: string;
}

const IconCatering = (props: IIconCatering) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} fill="none" {...props}>
    <path
      stroke="#3F2021"
      d="m13.852 7.063-.233.559.593.123c4.173.864 7.392 4.312 7.906 8.588H2.215c.514-4.276 3.733-7.724 7.906-8.588l.593-.123-.232-.56A1.84 1.84 0 0 1 12.167 4.5a1.84 1.84 0 0 1 1.685 2.564ZM1.667 18.5h21a.67.67 0 0 1 .666.667.67.67 0 0 1-.666.666h-21A.67.67 0 0 1 1 19.167a.67.67 0 0 1 .667-.667Z"
    />
  </svg>
);

export default IconCatering;
